import styled from 'styled-components'

export const SubscriptionWrapper = styled.div`
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};

  display: flex;
  flex-direction: column;

  height: 100%;

  overflow: auto;

  main {
    z-index: 2;
    /* flex: 1; */

    /* margin: ${({ theme }) => `${theme.spacings[10]} auto`}; */
    margin: 0 auto;
    padding: ${({ theme }) => `${theme.spacings[10]} 0`};

    height: 820px;
    width: 1238px;

    display: flex;
    flex-direction: column;
    align-items: center;
    background: red;

    background: #f9f9f9;
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);
    border-radius: 32px;
    overflow: hidden;

    h4 {
      font-family: ${({ theme }) => theme.fonts.bloggerSans};
      font-size: 34px;
      font-weight: 700;
      line-height: 37px;
      letter-spacing: 0.25px;
      text-align: center;
      margin-bottom: 80px;
    }
  }
`
